( function( $ ) {
	/**
	 * @param {undefined|jQuery.Event} [event]
	 */
	$.wpAdminBarHandler = function( event = undefined ) {
		if ( event instanceof jQuery.Event ) {
			// todo: some code
		}

		const $adminBar = $( '#wpadminbar' ),
			  $header   = $( 'header' );

		if ( $adminBar.length === 0 || $header.length === 0 ) {
			return;
		}

		const adminBarProps  = {
				  position : $adminBar.css( 'position' ),
				  height   : parseInt( $adminBar.css( 'height' ).replace( /[^0-9]+/, '' ), 10 )
			  },
			  headerProps    = {
				  position : $header.css( 'position' ),
				  top      : parseInt( $header.css( 'top' ).replace( /[^0-9]+/, '' ), 10 )
			  },
			  headerDefaults = JSON.parse( localStorage.headerDefaults );

		if ( adminBarProps.position === 'fixed' && headerProps.position === 'fixed' ) {
			$header.css( {
				top : adminBarProps.height + 'px'
			} );
		}
		else if ( adminBarProps.position !== 'fixed' && headerProps.position === 'fixed' ) {
			$header.css( {
				top : ( window.scrollY > 0 && window.scrollY <= adminBarProps.height ?
					adminBarProps.height - window.scrollY :
					window.scrollY > adminBarProps.height ?
						headerDefaults.top :
						adminBarProps.height )
					+ 'px'
			} );
		}
		else {
			$header.css( {
				top : headerDefaults.top + 'px'
			} );

		}
	};
} )( jQuery );

jQuery( document ).ready( function( $ ) {
	const $window = $( window ),
		  $header = $( 'header' );

	localStorage.headerDefaults = JSON.stringify( {
		position : $header.css( 'position' ),
		top      : parseInt( $header.css( 'top' ).replace( /[^0-9]+/, '' ), 10 )
	} );

	$.wpAdminBarHandler();

	$window.on( 'resize scroll', function( event ) {
		$.wpAdminBarHandler( event );
	} );
} );